var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99369 1.30127C4.65697 1.30127 1.95203 4.00622 1.95203 7.34294C1.95203 10.6797 4.65697 13.3846 7.99369 13.3846C9.62758 13.3846 11.11 12.736 12.1975 11.6823C12.2162 11.6568 12.2371 11.6324 12.2601 11.6093C12.2831 11.5863 12.3075 11.5654 12.333 11.5467C13.3868 10.4592 14.0354 8.97683 14.0354 7.34294C14.0354 4.00622 11.3304 1.30127 7.99369 1.30127ZM13.5728 12.0381C14.6414 10.7696 15.2854 9.13146 15.2854 7.34294C15.2854 3.31586 12.0208 0.0512695 7.99369 0.0512695C3.96662 0.0512695 0.702026 3.31586 0.702026 7.34294C0.702026 11.37 3.96662 14.6346 7.99369 14.6346C9.78222 14.6346 11.4203 13.9907 12.6889 12.922L15.8851 16.1182C16.1292 16.3623 16.5249 16.3623 16.769 16.1182C17.0131 15.8742 17.0131 15.4784 16.769 15.2343L13.5728 12.0381Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6c7cad202ce91ba24c283364ac30cc2a.svg";
export { ForwardRef as ReactComponent };